import React, { useState, useEffect, useRef } from 'react';
import "./InstallAll.css"; // Ваш CSS файл

function AllUsersInstallations() {
  const [allUsersData, setAllUsersData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [groupedReports, setGroupedReports] = useState({});
  const [archivedSessions, setArchivedSessions] = useState(new Set());
  const [showArchived, setShowArchived] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [isGeneralPoolCollapsed, setIsGeneralPoolCollapsed] = useState(false);
  const [isArchivePoolCollapsed, setIsArchivePoolCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  
  // Референси для збереження стану між оновленнями
  const groupedReportsRef = useRef({});
  const archivedSessionsRef = useRef(new Set());
  const lastUpdateTimeRef = useRef(Date.now());
  
  // Додайте ці стани для PlanFix
  const [planfixLoading, setPlanfixLoading] = useState(false);
  const [planfixMessage, setPlanfixMessage] = useState('');
  const [parseLoading, setParseLoading] = useState(false);
  const [parseMessage, setParseMessage] = useState('');
  const [parsedServers, setParsedServers] = useState([]);

  // Нові стани для порівняння серверів
  const [compareLoading, setCompareLoading] = useState(false);
  const [compareMessage, setCompareMessage] = useState('');
  const [dangerousServers, setDangerousServers] = useState([]);
  const [allServersData, setAllServersData] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [filterDate, setFilterDate] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [showDangerousOnly, setShowDangerousOnly] = useState(false);

  // Статичний словник імен користувачів
  const userNamesMap = {
    '261': 'Пастушенко Карина',
    '262': 'Левицький Мар\'ян',
    '263': 'Стецько Андрій',
    '264': 'Сенишин Максим',
    '265': 'Грет Орест',
    '266': 'Козак Дмитро',
    '267': 'Герій Олег',
    '268': 'Островська Катерина',
    '269': 'Павлюк Микола',
    '270': 'Коневич Роман',
    '271': 'Здеорук Вікторія',
    '272': 'Чічкін Ігор',
    '273': 'Рихлінський Руслан',
    '274': 'Віролюбова Анастасія',
    '275': 'Николайчук Дарья',
    '276': 'Єсипович Євген',
    '277': 'Левицький Микита',
    '278': 'Здеорук Олександра',
    '279': 'Петрів Юрій',
    '280': 'Петрів Степан',
    '281': 'Рось Іван',
    '282': 'Бишко Данило',
    '283': 'Сальников Валентин',
    '285': 'Ванденко Максим',
    '286': 'Зеленіков Дмитро',
    '287': 'Сачовська Діана',
    '288': 'Дудар Максим',
    '289': 'Мелих Владислав'
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Функція для отримання імені користувача по ID
  const getUserDisplayName = (userId) => {
    return userNamesMap[userId] || `Користувач ${userId}`;
  };

  const refreshData = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  // Функція для отримання всіх звітів через ітерацію по користувачах
  const fetchAllUsersReports = async () => {
    try {
      setError('');
      
      // Отримуємо звіти для кожного користувача
      const allReports = [];
      
      // Використовуємо всі ID зі словника
      const userIds = Object.keys(userNamesMap);
      
      console.log('Завантаження даних для користувачів:', userIds);
      
      for (const userId of userIds) {
        try {
          const response = await fetch(`https://hub2.daolog.net/api/user-installation-reports/${userId}`);
          if (response.ok) {
            const data = await response.json();
            if (data.reports && Array.isArray(data.reports)) {
              console.log(`Отримано ${data.reports.length} звітів для користувача ${userId}`);
              data.reports.forEach(report => {
                allReports.push({
                  ...report,
                  user_id: userId // Додаємо ID користувача до кожного звіту
                });
              });
            }
          } else {
            console.log(`Немає даних для користувача ${userId}`);
          }
        } catch (error) {
          console.error(`Помилка завантаження для користувача ${userId}:`, error);
        }
      }
      
      console.log(`Всього отримано звітів: ${allReports.length}`);
      processReportsData(allReports);
      
    } catch (error) {
      console.error('Помилка завантаження даних:', error);
      setError('Не вдалося завантажити дані. Перевірте підключення до сервера.');
    } finally {
      setLoading(false);
    }
  };

  // Обробка отриманих звітів зі збереженням існуючих даних
  const processReportsData = (newReports) => {
    const filteredReports = newReports.filter(report => report.session_id);
    const sortedData = [...filteredReports].sort((a, b) => {
      return new Date(b.timestamp) - new Date(a.timestamp);
    });
    
    // Беремо поточний стан з референса
    const currentGrouped = { ...groupedReportsRef.current };
    
    const newGrouped = sortedData.reduce((acc, report) => {
      const { session_id, user_id } = report;
      if (!session_id) return acc;
      
      const sessionKey = `${user_id}_${session_id}`;
      
      if (!acc[sessionKey]) {
        acc[sessionKey] = [];
      }
      acc[sessionKey].push(report);
      return acc;
    }, currentGrouped);

    // Оновлюємо референс та стан
    groupedReportsRef.current = newGrouped;
    setGroupedReports(newGrouped);
    setAllUsersData(newGrouped);
    
    lastUpdateTimeRef.current = Date.now();
    console.log(`Оброблено сесій: ${Object.keys(newGrouped).length}`);
  };

  // Завантаження архівованих сесій
  const fetchAllArchivedSessions = async () => {
    try {
      const userIds = Object.keys(userNamesMap);
      const allArchivedSessions = new Set([...archivedSessionsRef.current]);
      
      for (const userId of userIds) {
        try {
          const response = await fetch(`https://hub2.daolog.net/api/archived-sessions/${userId}`);
          if (response.ok) {
            const data = await response.json();
            if (data.success && data.archivedSessions) {
              data.archivedSessions.forEach(sessionId => {
                allArchivedSessions.add(`${userId}_${sessionId}`);
              });
            }
          }
        } catch (error) {
          console.error(`Помилка завантаження архівів для ${userId}:`, error);
        }
      }
      
      // Оновлюємо референс та стан
      archivedSessionsRef.current = allArchivedSessions;
      setArchivedSessions(allArchivedSessions);
      
    } catch (error) {
      console.error('Помилка завантаження архівованих сесій:', error);
    }
  };

  // Завантаження небезпечних серверів
  const fetchDangerousServers = async () => {
    try {
      const response = await fetch('https://hub2.daolog.net/api/dangerous-servers');
      if (response.ok) {
        const data = await response.json();
        if (data.success && data.dangerous_servers) {
          setDangerousServers(data.dangerous_servers);
          console.log(`Завантажено ${data.dangerous_servers.length} небезпечних серверів`);
        }
      }
    } catch (error) {
      console.error('Помилка завантаження небезпечних серверів:', error);
    }
  };

  // Перше завантаження даних
  useEffect(() => {
    const initialLoad = async () => {
      setLoading(true);
      await Promise.all([
        fetchAllUsersReports(),
        fetchAllArchivedSessions(),
        fetchDangerousServers()
      ]);
    };
    
    initialLoad();
  }, []);

  // Інтервал для оновлення даних - кожні 30 секунд
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!document.hidden) {
        refreshData();
      }
    }, 30000);

    return () => clearInterval(intervalId);
  }, []);

  // Обробка оновлення даних при зміні refreshTrigger
  useEffect(() => {
    if (refreshTrigger > 0) {
      const updateData = async () => {
        await Promise.all([
          fetchAllUsersReports(),
          fetchAllArchivedSessions(),
          fetchDangerousServers()
        ]);
      };
      
      updateData();
    }
  }, [refreshTrigger]);

  const archiveSession = async (sessionKey, event) => {
    event.stopPropagation();
    
    try {
      const [userId, sessionId] = sessionKey.split('_');
      
      const response = await fetch(`https://hub2.daolog.net/api/archive-session/${userId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ sessionId }),
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          const newArchivedSessions = new Set([...archivedSessionsRef.current, sessionKey]);
          archivedSessionsRef.current = newArchivedSessions;
          setArchivedSessions(newArchivedSessions);
        }
      }
    } catch (error) {
      console.error('Помилка архівування сесії:', error);
    }
  };

  const unarchiveSession = async (sessionKey, event) => {
    event.stopPropagation();
    
    try {
      const [userId, sessionId] = sessionKey.split('_');
      
      const response = await fetch(`https://hub2.daolog.net/api/unarchive-session/${userId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ sessionId }),
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          const newArchivedSessions = new Set(archivedSessionsRef.current);
          newArchivedSessions.delete(sessionKey);
          archivedSessionsRef.current = newArchivedSessions;
          setArchivedSessions(newArchivedSessions);
        }
      }
    } catch (error) {
      console.error('Помилка відновлення сесії:', error);
    }
  };

  // Функція для завантаження логів сесії
  const downloadSessionLogs = (sessionId) => {
    try {
      const url = `https://hub2.daolog.net/api/webhook/download/${sessionId}`;
      window.open(url, '_blank');
    } catch (error) {
      console.error('Помилка завантаження логів:', error);
      alert('Не вдалося завантажити логи сесії');
    }
  };

  const getLatestReport = (sessionReports) => {
    if (!sessionReports || sessionReports.length === 0) return null;
    return sessionReports[0];
  };

  const getServerAddressForSession = (sessionReports) => {
    if (!sessionReports || sessionReports.length === 0) return 'Невідомий сервер';
    return sessionReports[0].server_address;
  };

  const getInstallationStatus = (reports) => {
    if (!reports || reports.length === 0) return 'no_data';
    
    const latestReport = reports[0];
    
    if (latestReport.action === 'error') {
      return 'error';
    }
    
    if ((latestReport.action === 'install' || latestReport.action === 'install_office') && latestReport.success) {
      return 'completed';
    }
    
    if ((latestReport.action === 'install_started' || latestReport.action === 'install_office_started')) {
      return 'in_progress';
    }
    
    if (!latestReport.success && latestReport.error_message && latestReport.error_message.trim() !== '') {
      return 'error';
    }
    
    return 'unknown';
  };

  const getDisplayStatus = (reports) => {
    const status = getInstallationStatus(reports);
    
    switch (status) {
      case 'completed':
        return 'Успішно';
      case 'in_progress':
        return 'Встановлення...';
      case 'error':
        return 'Помилка';
      case 'no_data':
        return 'Немає даних';
      default:
        return 'Невідомо';
    }
  };

  const getInstallationStartTime = (reports) => {
    if (!reports || reports.length === 0) return null;
    
    for (let i = reports.length - 1; i >= 0; i--) {
      const report = reports[i];
      if ((report.action === 'install_started' || report.action === 'install_office_started')) {
        return report.timestamp;
      }
    }
    
    return null;
  };

  const Timer = ({ startTime, status }) => {
    const [currentTime, setCurrentTime] = useState(Date.now());
    
    useEffect(() => {
      let intervalId;
      
      if (status === 'in_progress' && startTime) {
        intervalId = setInterval(() => {
          setCurrentTime(Date.now());
        }, 1000);
      }
      
      return () => {
        if (intervalId) {
          clearInterval(intervalId);
        }
      };
    }, [status, startTime]);
    
    if (status !== 'in_progress' || !startTime) return null;
    
    const startTimestamp = new Date(startTime).getTime();
    const timeDiff = currentTime - startTimestamp;
    const seconds = Math.floor(timeDiff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    
    return (
      <span className="all-users-server-timer">
        ({hours > 0 ? `${hours}г ` : ''}{minutes % 60}хв {seconds % 60}с)
      </span>
    );
  };

  // Функція для порівняння серверів
  const handleCompareServers = async () => {
    try {
      setCompareLoading(true);
      setCompareMessage('Порівняння серверів...');
      
      const response = await fetch('https://hub2.daolog.net/api/compare-servers', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      const data = await response.json();
      
      if (data.success) {
        setCompareMessage(
          `Порівняння завершено! Серверів: ${data.stats.total_servers}, ` +
          `Небезпечних: ${data.stats.dangerous_servers}, ` +
          `Безпечних: ${data.stats.safe_servers}`
        );
        
        // Зберігаємо всі сервери
        setAllServersData(data.all_servers || []);
        
        // Оновлюємо небезпечні сервери
        if (data.server_categories && data.server_categories.dangerous) {
          const dangerousServersList = data.server_categories.dangerous.map(server => ({
            server: server.server_address,
            added_date: data.comparison_date
          }));
          setDangerousServers(dangerousServersList);
        }
      } else {
        setCompareMessage(`Помилка: ${data.message}`);
      }
      
    } catch (error) {
      console.error('Помилка порівняння серверів:', error);
      setCompareMessage(`Помилка: ${error.message}`);
    } finally {
      setCompareLoading(false);
    }
  };

  // Функція для перевірки чи сервер є небезпечним
  const isServerDangerous = (serverAddress) => {
    if (!serverAddress || !dangerousServers.length) return false;
    return dangerousServers.some(server => 
      server.server.toLowerCase() === serverAddress.toLowerCase().trim()
    );
  };

  const getAllSessions = () => {
    return Object.keys(groupedReports)
      .filter(sessionKey => showArchived ? archivedSessions.has(sessionKey) : !archivedSessions.has(sessionKey))
      .map(sessionKey => {
        const reports = groupedReports[sessionKey];
        const latestReport = getLatestReport(reports);
        const serverAddress = getServerAddressForSession(reports);
        const status = getInstallationStatus(reports);
        const startTime = getInstallationStartTime(reports);
        const [userId, sessionId] = sessionKey.split('_');
        const isDangerous = isServerDangerous(serverAddress);
        
        return {
          sessionKey,
          userId,
          sessionId,
          serverAddress,
          reports,
          latestReport,
          displayStatus: getDisplayStatus(reports),
          status,
          isSuccess: status === 'completed',
          isInProgress: status === 'in_progress',
          isError: status === 'error',
          startTime,
          latestTimestamp: latestReport ? new Date(latestReport.timestamp) : new Date(0),
          isArchived: archivedSessions.has(sessionKey),
          userName: getUserDisplayName(userId),
          isDangerous: isDangerous
        };
      }).sort((a, b) => {
        // Сортуємо: спочатку небезпечні, потім за часом
        if (a.isDangerous && !b.isDangerous) return -1;
        if (!a.isDangerous && b.isDangerous) return 1;
        return b.latestTimestamp - a.latestTimestamp;
      });
  };

  // Фільтрація сесій
  const getFilteredSessions = () => {
    let sessions = getAllSessions();
    
    // Фільтр за текстом (ім'я користувача, адреса сервера)
    if (filterText) {
      const searchText = filterText.toLowerCase();
      sessions = sessions.filter(session => 
        session.userName.toLowerCase().includes(searchText) ||
        session.serverAddress.toLowerCase().includes(searchText) ||
        session.userId.includes(searchText)
      );
    }
    
    // Фільтр за датою
    if (filterDate) {
      const filterDateObj = new Date(filterDate);
      sessions = sessions.filter(session => {
        if (!session.latestReport || !session.latestReport.timestamp) return false;
        const reportDate = new Date(session.latestReport.timestamp);
        return reportDate.toDateString() === filterDateObj.toDateString();
      });
    }
    
    // Фільтр за статусом
    if (filterStatus !== 'all') {
      sessions = sessions.filter(session => {
        switch (filterStatus) {
          case 'dangerous': return session.isDangerous;
          case 'in_progress': return session.isInProgress;
          case 'completed': return session.isSuccess;
          case 'error': return session.isError;
          default: return true;
        }
      });
    }
    
    // Фільтр тільки небезпечні
    if (showDangerousOnly) {
      sessions = sessions.filter(session => session.isDangerous);
    }
    
    return sessions;
  };

  const [timerUpdate, setTimerUpdate] = useState(0);
  
  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimerUpdate(prev => prev + 1);
    }, 1000);
    
    return () => clearInterval(intervalId);
  }, []);

  const createPipWindow = (serverAddress, sessionKey, userName) => {
    const pipWindow = window.open('', 'pipWindow', 
      'width=800,height=600,popup=yes,alwaysRaised=yes,alwaysOnTop=yes');
    
    if (!pipWindow) {
      alert('Спливаючі вікна заблоковані браузером. Будь ласка, дозвольте їх для цього сайту.');
      return;
    }
    
    const style = pipWindow.document.createElement('style');
    style.textContent = `
      body {
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        margin: 0;
        padding: 0;
        overflow-x: hidden;
        background-color: white;
      }
      
      .pip-container {
        width: 100%;
        min-height: 100vh;
        display: flex;
        flex-direction: column;
      }
      
      .pip-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px;
        background-color: #282c34;
        color: white;
        position: sticky;
        top: 0;
        z-index: 100;
      }
      
      .pip-header h3 {
        margin: 0;
        font-size: 16px;
      }
      
      .pip-header-buttons {
        display: flex;
        gap: 10px;
      }
      
      .pip-button {
        background-color: #007bff;
        color: white;
        border: none;
        padding: 5px 10px;
        border-radius: 4px;
        cursor: pointer;
        font-weight: bold;
        font-size: 12px;
      }
      
      .pip-button:hover {
        background-color: #0056b3;
      }
      
      .download-logs-button {
        background-color: #28a745;
      }
      
      .download-logs-button:hover {
        background-color: #218838;
      }
      
      .exit-pip-button {
        background-color: #f44336;
      }
      
      .exit-pip-button:hover {
        background-color: #d32f2f;
      }
      
      .pip-content {
        flex: 1;
        padding: 10px;
        overflow-y: auto;
      }
      
      table {
        width: 100%;
        border-collapse: collapse;
      }
      
      th, td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;
        font-size: 12px;
      }
      
      th {
        background-color: #f2f2f2;
        font-weight: bold;
        position: sticky;
        top: 0;
        z-index: 10;
        background-color: #f2f2f2;
      }
      
      tr:nth-child(even) {
        background-color: #f5f5f5;
      }
      
      tr:hover {
        background-color: #e9e9e9;
      }
      
      .success-true {
        color: green;
      }
      
      .success-false {
        color: red;
      }
      
      .error-message {
        max-width: 300px;
        overflow-wrap: break-word;
        word-wrap: break-word;
        hyphens: auto;
      }
      
      .user-info {
        background-color: #e3f2fd;
        padding: 8px;
        margin-bottom: 10px;
        border-radius: 4px;
        font-weight: bold;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      
      .user-details {
        flex: 1;
      }
      
      .download-section {
        text-align: right;
      }
      
      .dangerous-badge {
        background-color: #dc3545;
        color: white;
        padding: 3px 8px;
        border-radius: 12px;
        font-size: 11px;
        margin-left: 8px;
      }
    `;
    pipWindow.document.head.appendChild(style);
    
    const [userId, sessionId] = sessionKey.split('_');
    const serverData = groupedReports[sessionKey] || [];
    const isDangerous = isServerDangerous(serverAddress);

    const formatDateTime = (dateTimeString) => {
      const date = new Date(dateTimeString);
      return date.toLocaleString();
    };
    
    const content = `
      <div class="pip-container">
        <div class="pip-header">
          <h3>Звіти встановлення для сервера: ${serverAddress}</h3>
          <div class="pip-header-buttons">
            <button class="pip-button download-logs-button" id="download-button">
              Завантажити логи
            </button>
            <button class="pip-button exit-pip-button" id="exit-button">
              Закрити
            </button>
          </div>
        </div>
        
        <div class="pip-content">
          <div class="user-info">
            <div class="user-details">
              <strong>Користувач:</strong> ${userName} | 
              <strong>ID:</strong> ${userId} | 
              <strong>Сесія:</strong> ${sessionId}
              ${isDangerous ? '<span class="dangerous-badge">⚠ Небезпечний сервер</span>' : ''}
            </div>
            <div class="download-section">
              <button class="pip-button" id="quick-download-button" style="background-color: #6f42c1;">
                Швидке завантаження
              </button>
            </div>
          </div>
          <div class="table-container">
            <table>
              <thead>
                <tr>
                  <th>Версія</th>
                  <th>Тип встановлення</th>
                  <th>Статус</th>
                  <th>Дія</th>
                  <th>Час</th>
                  <th>Помилка</th>
                </tr>
              </thead>
              <tbody id="table-body">
                ${serverData.length > 0 ? 
                  serverData.map((report, index) => `
                    <tr>
                      <td>${report.version}</td>
                      <td>${report.install_type}</td>
                      <td class="success-${report.success}">${report.success ? 'Успішно' : 'Помилка'}</td>
                      <td>${report.action}</td>
                      <td>${formatDateTime(report.timestamp)}</td>
                      <td><div class="error-message">${report.error_message || '-'}</div></td>
                    </tr>
                  `).join('') : '<tr><td colspan="6">Немає даних</td></tr>'}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    `;
    
    pipWindow.document.body.innerHTML = content;
    
    // Додаємо обробники подій
    const exitButton = pipWindow.document.getElementById('exit-button');
    const downloadButton = pipWindow.document.getElementById('download-button');
    const quickDownloadButton = pipWindow.document.getElementById('quick-download-button');
    
    if (exitButton) {
      exitButton.addEventListener('click', () => {
        pipWindow.close();
      });
    }
    
    if (downloadButton) {
      downloadButton.addEventListener('click', () => {
        downloadSessionLogs(sessionId);
      });
    }
    
    if (quickDownloadButton) {
      quickDownloadButton.addEventListener('click', () => {
        downloadSessionLogs(sessionId);
      });
    }
    
    pipWindow.focus();
  };

  // Нова комплексна функція для PlanFix
  const handlePlanFixProcess = async () => {
    try {
      setPlanfixLoading(true);
      setPlanfixMessage('Початок комплексного процесу PlanFix...');
      
      // Крок 1: Викликаємо endpoint для повного процесу
      const response = await fetch('https://hub2.daolog.net/api/planfix-full-process', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      const data = await response.json();
      
      if (data.success) {
        setPlanfixMessage(
          `Процес завершено за ${data.duration}` +
          `Відфільтровано серверів: ${data.stats.filteredServers}. ` +
          `Report ID: ${data.stats.reportId}`
        );
      } else {
        setPlanfixMessage(`Помилка: ${data.message}`);
      }
      
    } catch (error) {
      console.error('Помилка PlanFix процесу:', error);
      setPlanfixMessage(`Помилка: ${error.message}`);
    } finally {
      setPlanfixLoading(false);
    }
  };

  const parseJSONFile = async () => {
    try {
      setParseLoading(true);
      setParseMessage('Початок парсингу файлу...');
      
      const response = await fetch('https://hub2.daolog.net/api/parse-json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({}),
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP ${response.status}: ${errorText.substring(0, 100)}...`);
      }
      
      const data = await response.json();
      
      if (data.success) {
        setParseMessage(`Успішно! Знайдено: ${data.stats.foundInFile}, Нові: ${data.stats.new}, Загалом: ${data.stats.total}`);
        setParsedServers(data.servers || []);
        
        // Оновлюємо дані через 2 секунди
        setTimeout(() => {
          fetchParsedServers();
        }, 2000);
      } else {
        setParseMessage(`Помилка: ${data.message}`);
      }
      
    } catch (error) {
      console.error('Помилка парсингу файлу:', error);
      setParseMessage(`Помилка: ${error.message}`);
    } finally {
      setParseLoading(false);
    }
  };
  
  const fetchParsedServers = async () => {
    try {
      const response = await fetch('https://hub2.daolog.net/api/servers');
      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setParsedServers(data.servers || []);
        }
      }
    } catch (error) {
      console.error('Помилка завантаження серверів:', error);
    }
  };
  
  useEffect(() => {
    fetchParsedServers();
  }, []);
  
  useEffect(() => {
    const autoParse = async () => {
      try {
        console.log('Автоматичний парсинг файлу...');
        const response = await fetch('https://hub2.daolog.net/api/parse-json', {
          method: 'POST',
        });
        
        if (response.ok) {
          const data = await response.json();
          console.log('Автоматичний парсинг успішний:', data.stats);
          
          fetchParsedServers();
        }
      } catch (error) {
        console.error('Помилка автоматичного парсингу:', error);
      }
    };
    
    const intervalId = setInterval(autoParse, 10 * 60 * 1000);
    autoParse();
    
    return () => clearInterval(intervalId);
  }, []);

  const togglePipMode = (serverAddress, sessionKey, userName) => {
    createPipWindow(serverAddress, sessionKey, userName);
  };

  const ServerCard = ({ session }) => {
    const { sessionKey, userId, serverAddress, reports, displayStatus, isSuccess, isInProgress, isError, startTime, isArchived, userName, isDangerous } = session;
    
    const cardVariant = isSuccess ? 'completed' : isInProgress ? 'in-progress' : isError ? 'error' : 'default';
    const statusClass = isSuccess ? 'success' : isInProgress ? 'progress' : 'error';
    
    return (
      <div className={`all-users-server-card ${cardVariant} ${isArchived ? 'archived' : ''} ${isDangerous ? 'dangerous' : ''}`}>
        <div className="all-users-server-content">
          <div className="all-users-server-info">
            <div className="all-users-server-address-wrapper">
              <div className="all-users-server-address">
                {serverAddress || 'Невідомий сервер'}
                {isDangerous && (
                  <span className="all-users-dangerous-badge" title="Небезпечний сервер">
                    ⚠
                  </span>
                )}
              </div>
              <div className="all-users-user-name">Користувач: {userName}</div>
            </div>
            
            <div className="all-users-server-status-row">
              <span className={`all-users-server-status ${statusClass}`}>
                {displayStatus}
                {isDangerous && ' ⚠'}
              </span>
              {isInProgress && startTime && (
                <Timer 
                  key={`${sessionKey}-${timerUpdate}`}
                  startTime={startTime} 
                  status={isInProgress ? 'in_progress' : 'completed'} 
                />
              )}
            </div>
          </div>
          
          <div className="all-users-server-actions">
            <button 
              onClick={() => togglePipMode(serverAddress, sessionKey, userName)} 
              className="all-users-detail-button"
              title="Детальніше"
            >
              →
            </button>
            {!showArchived && (
              <button 
                onClick={(e) => archiveSession(sessionKey, e)}
                className="all-users-archive-button"
                title="Перемістити в архів"
              >
                Архів
              </button>
            )}
            {showArchived && (
              <button 
                onClick={(e) => unarchiveSession(sessionKey, e)}
                className="all-users-unarchive-button"
                title="Відновити з архіву"
              >
                Відновити
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };
  

  const activeSessions = getFilteredSessions().filter(s => !s.isArchived);
  const archivedSessionsList = getFilteredSessions().filter(s => s.isArchived);
  const uniqueUsers = new Set(activeSessions.map(s => s.userId).concat(archivedSessionsList.map(s => s.userId)));

  if (loading) {
    return (
      <div className="all-users-container">
        <div className="all-users-header">
          <h1 className="all-users-title">Встановлення BackOffice / Chain - Всі користувачі</h1>
          <div className="all-users-subtitle">
            <span className="all-users-stats">Завантаження даних...</span>
          </div>
        </div>
        <div className="all-users-loading">
          <div className="all-users-loading-spinner"></div>
          <p>Завантаження даних всіх користувачів...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="all-users-container">
      <div className="all-users-header">
        <h1 className="all-users-title">Встановлення BackOffice / Chain - Всі користувачі</h1>
        <div className="all-users-subtitle">
          <span className="all-users-stats">Користувачів: {uniqueUsers.size}</span>
          <span className="all-users-stats">Оновлено: {new Date(lastUpdateTimeRef.current).toLocaleTimeString()}</span>
        </div>
      </div>
      
      {/* Фільтри */}
      <div className="all-users-filters">
        <div className="all-users-filter-group">
          <input
            type="text"
            placeholder="Пошук за користувачем або адресою..."
            value={filterText}
            onChange={(e) => setFilterText(e.target.value)}
            className="all-users-filter-input"
          />
          <input
            type="date"
            value={filterDate}
            onChange={(e) => setFilterDate(e.target.value)}
            className="all-users-filter-date"
          />
          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className="all-users-filter-select"
          >
            <option value="all">Всі статуси</option>
            <option value="dangerous">Небезпечні</option>
            <option value="in_progress">Встановлення...</option>
            <option value="completed">Успішні</option>
            <option value="error">Помилки</option>
          </select>
          <label className="all-users-filter-checkbox">
            <input
              type="checkbox"
              checked={showDangerousOnly}
              onChange={(e) => setShowDangerousOnly(e.target.checked)}
            />
            Тільки небезпечні
          </label>
          <button 
            onClick={() => {
              setFilterText('');
              setFilterDate('');
              setFilterStatus('all');
              setShowDangerousOnly(false);
            }}
            className="all-users-filter-clear"
          >
            Очистити
          </button>
        </div>
      </div>
      
      <div className="all-users-column-actions">
        <div className="all-users-view-toggle">
          <button 
            className={!showArchived ? 'all-users-active' : ''}
            onClick={() => setShowArchived(false)}
          >
            Поточні ({activeSessions.length})
          </button>
          <button 
            className={showArchived ? 'all-users-active' : ''}
            onClick={() => setShowArchived(true)}
          >
            Архів ({archivedSessionsList.length})
          </button>
        </div>
        <button className="all-users-refresh-button" onClick={refreshData}>
          Оновити дані
        </button>
        
        {/* Кнопка порівняння серверів */}
        <button 
          className="all-users-compare-button"
          onClick={handleCompareServers}
          disabled={compareLoading}
          title="Порівняти сервери з небезпечними"
        >
          {compareLoading ? 'Порівняння...' : 'Порівняти сервери'}
        </button>
        
        {/* Об'єднана кнопка PlanFix */}
        <button 
          className="all-users-planfix-button"
          onClick={handlePlanFixProcess}
          disabled={planfixLoading}
          title="Запустити повний процес PlanFix (отримання, збереження, парсинг)"
        >
          {planfixLoading ? 'PlanFix...' : 'PlanFix'}
        </button>
      </div>
      
      {/* Повідомлення про порівняння */}
      {compareMessage && (
        <div className={`all-users-message ${compareMessage.includes('Помилка') ? 'error' : 'success'}`}>
          {compareMessage}
          {dangerousServers.length > 0 && (
            <span style={{marginLeft: '10px'}}>
              Небезпечних серверів: {dangerousServers.length}
            </span>
          )}
        </div>
      )}
      
      {/* Повідомлення про PlanFix */}
      {planfixMessage && (
        <div className={`all-users-message ${planfixMessage.includes('') ? 'success' : 'error'}`}>
          {planfixMessage}
        </div>
      )}
      
      {/* Повідомлення про парсинг */}
      {parseMessage && (
        <div className={`all-users-message ${parseMessage.includes('') ? 'success' : 'error'}`}>
          {parseMessage}
        </div>
      )}
      
      {error && (
        <div className="all-users-error-message">
          {error}
        </div>
      )}
      
      {/* Інформація про небезпечні сервери */}
      {dangerousServers.length > 0 && !showArchived && (
        <div className="all-users-dangerous-info">
          <div className="all-users-dangerous-header">
            ⚠️ Увага: Знайдено {dangerousServers.length} небезпечних серверів
            <button 
              className="all-users-dangerous-toggle"
              onClick={() => setShowDangerousOnly(!showDangerousOnly)}
            >
              {showDangerousOnly ? 'Показати всі' : 'Показати тільки небезпечні'}
            </button>
          </div>
        </div>
      )}
      
      {!showArchived ? (
        <div className="all-users-pool-section">
          <div className="all-users-pool-header">
            <div>
              <h2 className="all-users-pool-title">
                Загальний пул - Всі користувачі
                <span className="all-users-server-count">({activeSessions.length})</span>
                {dangerousServers.length > 0 && (
                  <span className="all-users-dangerous-count">
                    ⚠ {dangerousServers.length} небезпечних
                  </span>
                )}
              </h2>
            </div>
            <button 
              className="all-users-collapse-btn"
              onClick={() => setIsGeneralPoolCollapsed(!isGeneralPoolCollapsed)}
              title={isGeneralPoolCollapsed ? "Розгорнути" : "Згорнути"}
            >
              {isGeneralPoolCollapsed ? '▼' : '▲'}
            </button>
          </div>
          
          {!isGeneralPoolCollapsed && (
            <div className="all-users-servers-list">
              {activeSessions.length > 0 ? (
                activeSessions.map((session) => (
                  <ServerCard key={session.sessionKey} session={session} />
                ))
              ) : (
                <div className="all-users-no-data">
                  {filterText || filterDate || filterStatus !== 'all' || showDangerousOnly
                    ? 'Немає серверів за поточними фільтрами'
                    : 'Немає активних серверів'}
                </div>
              )}
            </div>
          )}
        </div>
      ) : (
        <div className="all-users-pool-section">
          <div className="all-users-pool-header">
            <div>
              <h2 className="all-users-pool-title">
                Архів - Всі користувачі
                <span className="all-users-server-count">({archivedSessionsList.length})</span>
              </h2>
            </div>
            <button 
              className="all-users-collapse-btn"
              onClick={() => setIsArchivePoolCollapsed(!isArchivePoolCollapsed)}
              title={isArchivePoolCollapsed ? "Розгорнути" : "Згорнути"}
            >
              {isArchivePoolCollapsed ? '▼' : '▲'}
            </button>
          </div>
          
          {!isArchivePoolCollapsed && (
            <div className="all-users-servers-list">
              {archivedSessionsList.length > 0 ? (
                archivedSessionsList.map((session) => (
                  <ServerCard key={session.sessionKey} session={session} />
                ))
              ) : (
                <div className="all-users-no-data">
                  {filterText || filterDate || filterStatus !== 'all'
                    ? 'Немає серверів за поточними фільтрами'
                    : 'Немає архівованих серверів'}
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default AllUsersInstallations;